import React, { Component } from 'react';
import { getPracticeCasesByFilter } from '../../utils/api/services/contest';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import PracticeCard from './PracticeCard';
import CategoriesAndTagsPanel from './CategoriesAndTagsPanel';
import ListFooter from '../../components/ListFooter/ListFooter';
import Preloader from '../../components/Preloader/Preloader';
import queryString from 'query-string';
import { setUrlParameters } from '../../utils/helpers';
import practiceConstants from './practiceConstants';
import { getPage, getQuery, getTags, getSort, getCategory } from '../../utils/urlHelper';
import paths from '../../paths';

export default class Practice extends Component {
  constructor(props) {
    super(props);

    this.defaultSort = practiceConstants.sortTypes[0];
    this.pageSize = 8;

    this.state = {
      isLoading: true,
      isLoadingSelectedTags: false,
      practice: [],
      total: 0,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      this.fetchPracticeData();
    }
  }

  componentWillMount = () => {
    this.fetchPracticeData();
  };

  fetchPracticeData = (more = false) => {
    this.setState({ isLoading: true, isLoadingSelectedTags: true });

    const page = getPage();
    const selectedTags = getTags();
    const selectedSort = getSort() || this.defaultSort.alias;
    const selectedCategory = getCategory() || practiceConstants.allCategory.alias;

    getPracticeCasesByFilter(
      selectedCategory,
      selectedTags,
      selectedSort,
      this.pageSize,
      (page - 1) * this.pageSize,
    )
      .then((result) => {
        if (more) {
          this.setState({
            practice: [...this.state.practice, ...result.data],
            total: result.total,
          });
        }
        else {
          this.setState({
            practice: result.data,
            total: result.total,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingSelectedTags: false
        });
      });
  };

  onChangeCategory = (category) => {
    let urlQuery = {};
    urlQuery["page"] = null;
    urlQuery["category"] = category || null;
    setUrlParameters(urlQuery, this.fetchPracticeData);
  };

  onChangeTags = (tags) => {
    let urlQuery = {};
    urlQuery["tags"] = tags.join(',');
    urlQuery["page"] = null;
    setUrlParameters(urlQuery, this.fetchPracticeData);
  };

  onChangeSort = (sort) => {
    let urlQuery = {};
    urlQuery["sort"] = sort.alias === this.defaultSort.alias ? null : sort.alias;
    urlQuery["page"] = null;
    setUrlParameters(urlQuery, this.fetchPracticeData);
  };

  handlePageClick = (e) => {
    const newPage = Number(e.selected) + 1;

    let urlQuery = {};
    urlQuery["page"] = newPage > 1 ? newPage : null;
    setUrlParameters(urlQuery, this.fetchPracticeData);
  };
  handleLoadMore = () => {
    const page = getPage();
    const newPage = page + 1;
    const urlQuery = {};
    urlQuery.page = newPage > 1 ? newPage : null;
    setUrlParameters(urlQuery);

    this.setState(
      {
        isLoadingMore: true
      },
      () => this.fetchPracticeData(true),
    );
  };

  renderCards = (practice, page, total) => {
    return (
      <div className="section">
        {practice.length ? (
          <React.Fragment>
            <div className="card">
              {practice.slice(0, 2).map(item => (
                <PracticeCard key={item.id} practice={item} />
              ))}
            </div>
            <div className="card -col3">
              {practice.slice(2, practice.length).map(item => (
                <PracticeCard key={item.id} practice={item} />
              ))}
            </div>
          </React.Fragment>
        ) : (
          <div> Кейсов нет :( </div>
        )}

        <ListFooter
          counterLabel="документов"
          pageSize={this.pageSize}
          currentPage={page}
          total={total}
          handlePageClick={this.handlePageClick}
          handleLoadMore={this.handleLoadMore}
        />
      </div>
    );
  };

  render() {
    const {
      practice, total, isLoading, isLoadingSelectedTags
    } = this.state;

    const selectedCategoryAlias = getCategory() || practiceConstants.allCategory.alias;
    const selectedSortAlias = getSort() || this.defaultSort;
    const selectedTagsStr = getTags();
    const page = getPage();

    const selectedTags = selectedTagsStr ? selectedTagsStr.split(',') : [];

    return (
      <React.Fragment>
        <div className="b-center">
          <BreadCrumbs
            data={[{ url: paths.advocates.main, text: 'Главная' }, { url: paths.advocates.practice, text: 'Практика' }]}
          />
          <h1 className="title -primary">Случай из практики</h1>

          <div className="section">
            <CategoriesAndTagsPanel
              selectedCategoryAlias={selectedCategoryAlias}
              selectedSortAlias={selectedSortAlias}
              selectedTags={selectedTags}
              onChangeCategory={this.onChangeCategory}
              onChangeTags={this.onChangeTags}
              onChangeSort={this.onChangeSort}
              isLoadingSelectedTags={isLoadingSelectedTags}
            />
          </div>

          {isLoading ? <Preloader /> : this.renderCards(practice, page, total)}
        </div>
      </React.Fragment>
    );
  }
}
